function aggregateBody(form) {
  const fields = form.querySelectorAll('[data-body-label]');
  const lines = [];

  fields.forEach((field) => {
    const label = field.dataset.bodyLabel;
    let value = (field.value || '').trim();
    if (field.type === 'checkbox') {
      if (!field.checked) {
        field.removeAttribute('name');
        return;
      }
      value = value || 'da';
    }
    if (!value) {
      field.removeAttribute('name');
      return;
    }
    lines.push(`${label}: ${value}`);
    field.removeAttribute('name');
  });

  const bodyEl = form.querySelector('[name="contact[body]"]');
  const userMsg = bodyEl ? (bodyEl.value || '').trim() : '';

  let combined = lines.join('\n');
  if (userMsg) {
    combined += '\n\n---\nDescriere:\n' + userMsg;
  }

  if (bodyEl) {
    bodyEl.value = combined;
  } else if (combined) {
    const hidden = document.createElement('input');
    hidden.type = 'hidden';
    hidden.name = 'contact[body]';
    hidden.value = combined;
    form.appendChild(hidden);
  }
}

document.addEventListener(
  'submit',
  (e) => {
    const form = e.target;
    if (form && form.tagName === 'FORM' && form.querySelector('[data-aggregate-body-marker]')) {
      aggregateBody(form);
    }
  },
  true
);
